import * as React from 'react';
export const raiffeisenSvg = React.forwardRef(function raiffeisenSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#000',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fillRule: 'nonzero',
          transform: 'translate(1 1)',
        },
        /*#__PURE__*/ React.createElement('rect', {
          width: 29.09,
          height: 29.09,
          x: 0.46,
          y: 0.46,
          fill: '#F8F400',
          rx: 3,
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#000',
          d: 'M7.73 4.82c-.9.09-1.75.49-2.39 1.13a6.84 6.84 0 0 0-1.98 4.74l1-1.01 3.85 3.84.97-1.05V9.9l1.46 1.12v3.05l1.52 1.56-8.07 7.83 3.11 3.08 7.8-7.8 7.9 7.9 3.05-3.1-8.05-7.9 1.46-1.53v-3.08l1.47-1.12v2.56l1.07 1.05 3.71-3.86 1.04 1.03c0-.65-.16-2.95-2.01-4.74a3.29 3.29 0 0 0-4.8-.14L16.1 9.23l.95.93L15 12.12l-2.08-1.96.92-.93-3.71-3.42a3.07 3.07 0 0 0-2.42-.98l.02-.01z',
        }),
      ),
    ),
  );
});
raiffeisenSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var raiffeisen = {
  category: 'brand',
  colorable: false,
  name: 'raiffeisen',
  svg: raiffeisenSvg,
};
